import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { issueCreditNote } from './api';
import type { IssueCreditNoteInput } from './types';

export function useIssueCreditNote(billId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: IssueCreditNoteInput) => issueCreditNote(billId, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.billing.list() });
      queryClient.invalidateQueries({ queryKey: keys.billing.items(billId) });
      queryClient.invalidateQueries({ queryKey: keys.billing.creditNotes(billId) });
    },
  });
}
